import type { NotificationData } from '~/@types/cms';

// https://pinia.vuejs.org/core-concepts/#setup-stores
export const useNotificationStore = defineStore('woom-store-notification', () => {
    const sessionStorageKey = 'closedNotificationIds';
    const closedNotificationIds = ref(new Set<string>());
    const addClosedNotificationId = (id: string) => {
        closedNotificationIds.value.add(id);
        sessionStorage.setItem(sessionStorageKey, JSON.stringify([...closedNotificationIds.value]));
    };
    const initClient = async () => {
        await nextTick();
        const storedIdsString = sessionStorage.getItem(sessionStorageKey) ?? '[]';
        const storedIds: string[] = JSON.parse(storedIdsString);
        storedIds.forEach((id) => addClosedNotificationId(id));
    };
    if (import.meta.browser) {
        initClient();
    }

    const notifications = ref<NotificationData[]>([]);
    const { queryParams } = usePreview();
    const fetchOptions = useGenericFetchOptions();
    const fetchNotifications = async () => {
        const { locale } = useLocales();
        try {
            const response = await $fetch('/api/notifications', {
                params: {
                    locale: locale.value,
                    ...queryParams.value,
                },
                ...fetchOptions,
            });

            notifications.value = (response?.data?.getNotifications ?? [])
                .map((notification) => {
                    const data = notification.data;
                    if (!data) return;
                    return {
                        id: notification.id,
                        lang: notification.lang,
                        project: notification.project,
                        refs: notification.refs,
                        data: {
                            ...(data as Partial<NotificationData['data']>),
                            close_button: 'close_button' in data && data.close_button === 'enabled',
                            path_excludes: ('path_excludes' in data && typeof data.path_excludes === 'string' && data.path_excludes.split(',')) || [],
                        },
                    } as NotificationData;
                })
                .filter(isDefined);
        } catch (err) {
            console.log('notifications error', err); // eslint-disable-line no-console
            throw err;
        }
    };

    return { closedNotificationIds, notifications, addClosedNotificationId, fetchNotifications };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useNotificationStore, import.meta.hot));
}
